import React, { useEffect, useState } from 'react';
import {
  ALL_MODULES,
  DEFAULT_FIELDS_BY_COLUMN_NAME,
  InlineEdit,
  InlineEditTableWrapper,
  Loader,
  StatusDropdown,
  ApiProgressLoader
} from '@nile/components';
import { useQuery } from '@apollo/client';
import { AccountClient, GET_FIELD } from '@nile/graphql';
import styled from 'styled-components';
import { StyledTag } from '@nile/components/src/Components/InlineEdit/Components/InlineSelect';
import { SVGIcon } from '@superops/super-icons';

let timerId = null;

const Wrap = styled.div`
  max-width: 100%;
  min-height: 38px;
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
`;

function InlineStatusCell(props) {
  const { _ticket, cell, params, hideTag, editCellId } = props;
  const ticket = _ticket || cell?.row?.original;
  const allProps = params || cell.column;
  const { actions, editable, shouldFreezeCell, setEditCell } = allProps;
  const isCellFreezed = shouldFreezeCell && shouldFreezeCell(cell);
  const isEditable = !isCellFreezed && editable;
  const [options, setOptions] = useState([]);
  const [apiProgress, setApiProgress] = useState(false);
  const [apiResult, setApiResult] = useState(null);
  const setApiComplete = (state) => {
    setApiProgress(false);
    setApiResult(state);
    if (timerId) clearTimeout(timerId);
    timerId = setTimeout(() => {
      setApiResult(null);
    }, 2000);
  };

  const [selectedOption, setSelectedOption] = useState(
    ticket?.status
      ? { name: ticket.status, value: ticket.status, label: ticket.status }
      : null
  );

  useEffect(() => {
    setSelectedOption({
      name: ticket.status,
      value: ticket.status,
      label: ticket.status
    });
  }, [ticket?.status]);

  if (editCellId && editCellId === cell.id) {
    return (
      <EditStatus
        cell={cell}
        ticket={ticket}
        setApiProgress={setApiProgress}
        setApiResult={setApiResult}
        actions={actions}
        hideTag={hideTag}
        setApiComplete={setApiComplete}
        setEditCell={setEditCell}
      />
    );
  }

  return (
    <div className="fx fw actr">
      <InlineEditTableWrapper
        className="mw-100"
        key={cell?.value}
        onClick={(e) => {
          if (isEditable) {
            setEditCell(cell.id);
            e.stopPropagation();
            e.preventDefault();
          }
        }}
      >
        <Wrap
          className={`${
            editable ? 'editable-cell' : ''
          } flex center g5 fw full-height inlineSelect`}
        >
          {hideTag ? (
            <div
              className="ellipsis self-center fg1 flex center full-height rounded-4px uppercase font-weight-600 width-text-with-icon"
              title={selectedOption?.label}
            >
              <div className="ellipsis">{selectedOption?.label}</div>
            </div>
          ) : (
            <StyledTag
              className="ellipsis self-center fw flex center full-height p4 pl10 pr10 rounded-4px uppercase font-weight-600"
              title={selectedOption?.label}
            >
              <div className="ellipsis">{selectedOption?.label}</div>
            </StyledTag>
          )}
          {apiProgress && <ApiProgressLoader isLoading />}
          {apiResult && (
            <ApiProgressLoader isSuccess={apiResult === 'success'} />
          )}
          {isEditable && (
            <div className="edit-actions">
              {
                <div className="ml8 fx center">
                  <SVGIcon name="Edit" />
                </div>
              }
            </div>
          )}
        </Wrap>
      </InlineEditTableWrapper>
    </div>
  );
}

function EditStatus(props) {
  const {
    ticket,
    setApiProgress,
    setApiResult,
    actions,
    hideTag,
    cell,
    setApiComplete,
    setEditCell
  } = props;
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const { loading } = useQuery(GET_FIELD, {
    client: AccountClient,
    variables: {
      input: {
        module: ALL_MODULES.ticket,
        columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.STATUS
      }
    },
    onCompleted: (res) => {
      if (res.getField) {
        const fldOptions =
          res?.getField?.options || res?.getField?.fieldOptions;
        const structuredOptions = fldOptions?.map((element) => {
          return {
            ...element,
            name: element?.value,
            value: element?.value,
            label: element?.value
          };
        });
        setOptions(structuredOptions);
      }
    }
  });

  useEffect(() => {
    if (options.length && ticket.status) {
      const optionSelected = options.find(
        ({ value }) => value.trim() === ticket.status.trim()
      );
      setSelectedOption(
        optionSelected || {
          name: ticket.status,
          value: ticket.status,
          label: ticket.status
        }
      );
    }
  }, [options.length, ticket?.status]);
  if (loading || !selectedOption || !options) return <div>...</div>;
  return (
    <div className="fx fw actr">
      <InlineEditTableWrapper className="w100 mw-90" key={cell?.value}>
        <StatusDropdown
          selectedOption={selectedOption}
          options={options}
          updateSelectedProperties={(value) => {
            actions.save &&
              actions.save(value, ticket, props.data, setApiComplete);
            setApiProgress(true);
            setEditCell(null);
          }}
          mode="edit"
          hideTag={hideTag}
          skipListener
          menuClassName="min-width-250"
        />
      </InlineEditTableWrapper>
    </div>
  );
}

export default React.memo(InlineStatusCell);
